import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { EmptyState404illustration } from "@dreamhub/designsystem/icons";

interface NotFoundPageProps {
  "data-test"?: string;
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({
  "data-test": dataTest = "not-found-page"
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className="flex h-full w-full items-center justify-center"
      data-test={dataTest}
    >
      <div className="flex items-center gap-16">
        <EmptyState404illustration />
        <div className="flex flex-col gap-4">
          <Text variant="title1H1">{t("notFoundPage.title")}</Text>
          <Text variant="lgLabelSecondary" className="max-w-[400px]">
            {t("notFoundPage.description")}
          </Text>
          <Button
            variant="secondary"
            onClick={() => navigate("/")}
            className="w-fit mt-2"
          >
            {t("notFoundPage.backToHome")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
